<template>
    <div class="content">
        <div class="jumbotron" data-pages="parallax">
            <div class="container-fluid container-fixed-lg sm-p-l-0 sm-p-r-0">
                <div class="inner" style="transform: translateY(0px); opacity: 1;">
                    <ol class="breadcrumb" style="margin-top: 10px;">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <a href="#">League of Legends Tools</a>
                        </li>
                        <li class="breadcrumb-item active">LOL Stats - Configurator</li>
                    </ol>
                </div>
            </div>
        </div>

        <div class="pgn-wrapper" data-position="top" style="top: 60px;">
            <div class="pgn push-on-sidebar-open pgn-bar">
                <div class="alert alert-info">
                    <button type="button" class="close" data-dismiss="alert">
                        <i class="pg-close" style="color: black !important;"></i>
                    </button>
                    <b>Note:</b> This project isn’t endorsed by Riot Games and doesn’t reflect the views or opinions of Riot Games
                    or anyone officially involved in producing or managing League of Legends. League of Legends and Riot Games are
                    trademarks or registered trademarks of Riot Games, Inc. League of Legends © Riot Games, Inc. Please contact us for more information or if you are experiencing any problems.
                    <br />
                    <a href="mailto:info@jep-dev.com">
                        <b>Contact us</b>
                    </a>
                    <a
                        style="display:none"
                        class="contact-us"
                        data-target="#modalFillIn"
                        data-toggle="modal"
                    >
                        <b>Contact us</b>
                    </a>
                </div>
            </div>
        </div>

        <div class="container-fluid container-fixed-lg sm-p-l-0 sm-p-r-0">
            <div class="row">
                <div class="col-12">
                    <h1>League of Legends Stats - Configurator</h1>
                    <p>This tool should help you to create the correct API command.</p>
                </div>
            </div>
            <div class="row m-t-24">
                <div class="col-6">
                    <h2>Settings:</h2>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group form-group-default form-group-default-select2 required">
                                <label class>Region</label>
                                <select2
                                    :options="settings.regions"
                                    v-model="selection.region"
                                    :settings="{ placeholder: 'Select a Region' }"
                                ></select2>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group form-group-default form-group-default-select2 required" style="overflow:unset">
                                <label class>Game(s)</label>
                                <multiselect
                                    :options="settings.games"
                                    v-model="selection.games"
                                    placeholder="Select a Game"
                                    :close-on-select="false"
                                    :multiple="true"
                                    :preselect-first="true"
                                    label="text"
                                    track-by="id"
                                >
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group form-group-default required">
                                <label class>Summoner Name (Comma Seperated)</label>
                                <input
                                    v-model="selection.summonername"
                                    type="text"
                                    class="form-control required"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group form-group-default form-group-default-select2 required">
                                <label class>Command</label>
                                <select2
                                    :options="settings.commands"
                                    v-model="selection.command"
                                    :settings="{ placeholder: 'Select a Command' }"
                                ></select2>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group form-group-default form-group-default-select2 required">
                                <label>Portal</label>
                                <select2
                                    :options="settings.portals"
                                    v-model="selection.portal"
                                    :settings="{ placeholder: 'Select a Portal' }"
                                ></select2>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group form-group-default required">
                                <label class>Portal Command (e.g. !elo)</label>
                                <input
                                    v-model="selection.portal_command"
                                    type="text"
                                    class="form-control required"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <h2>Result</h2>
                    <p>
                        <b>Add:</b>
                        <br />
                        {{ command_output_add }}
                        <br />
                        <br />
                    </p>
                    <p>
                        <b>Edit:</b>
                        <br />
                        {{ command_output_edit }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .select2-container--default .select2-selection--single .select2-selection__arrow {
        top: auto!important
    }
    .multiselect__placeholder {
        margin-top: 16px;
        padding-left: 12px;
    }
    .multiselect__tags{
        border: 0;
    }
    .multiselect__tag {
        margin-top: 24px;
    }
    .multiselect__select {
        bottom: 1px;
        top: unset;
        right: 0;
    }
    .multiselect__select:before{
        border-color: #888 transparent transparent transparent;
        border-width: 5px 4px 0;
    }
</style>

<script>
import Multiselect from 'vue-multiselect'

export default {
    data() {
        return {
            settings: {
                regions: [
                    { id: 'br1', text: 'BR' },
                    { id: 'eun1', text: 'EUNE' },
                    { id: 'euw1', text: 'EUW' },
                    { id: 'jp1', text: 'JP' },
                    { id: 'kr', text: 'KR' },
                    { id: 'la1', text: 'LAN' },
                    { id: 'la2', text: 'LAS' },
                    { id: 'na', text: 'NA' },
                    { id: 'oc1', text: 'OCE' },
                    { id: 'tr1', text: 'TR' },
                    { id: 'ru', text: 'RU' },
                    { id: 'pbe1', text: 'PBE' }
                ],
                commands: [
                    { id: 'rank', text: 'Ranked Information' },
                    { id: 'game', text: 'Active Game' }
                ],
                games: [
                    { id: 'lol', text: 'League of Legends' },
                    { id: 'tft', text: 'Teamfight Tactics' }
                ],
                portals: [
                    { id: 'twitch', text: 'Twitch' }
                ],
            },
            selection: {
                region: '',
                summonername: '',
                games: [],
                command: '',
                portal: '',
                portal_command: ''
            }
        }
    },
    components: {
        'multiselect': Multiselect
    },
    methods: {
        get_summoner_name: function(value){
            var values = value.split(',');
            var new_value = '';
            for(var i=0;i<values.length;i++){
                if(i!=0)
                    new_value += ',';
                new_value += encodeURIComponent(values[i].trim())
            }
            return new_value
        },
        get_command_output: function(type){

            if(this.selection.region == '' ||
                this.selection.summername == '' ||
                this.selection.command == '' ||
                this.selection.portal == '' ||
                this.selection.portal_command == '' ||
                this.selection.games.length == 0
            )
                return 'Please set all required settings first.';

            var api_url = 'https://api.lolstats.fourzero.one/v3/';
            var game = 'all';
            var game_query = '';
            if(this.selection.games.length == 1)
                game = this.selection.games[0].id;
            else {
                game_query = '&g=' + this.selection.games.map(function(elem){
                    return elem.id;
                }).join(',');
            }

            var summoner_name = this.get_summoner_name(this.selection.summonername)
            var output = `${this.selection.portal_command} $(eval const api=$(urlfetch ${api_url}${game}/${this.selection.region}/${this.selection.command}?s=${summoner_name}${game_query});api.message)`;
            if(this.selection.portal == 'twitch'){
                if(type == 'add')
                    return '!addcom ' + output
                else if(type == 'edit')
                    return '!editcom ' + output
            }
            return ''
        }
    },
    computed: {
        command_output_add: function(){
            return this.get_command_output('add');
        },
        command_output_edit: function(){
            return this.get_command_output('edit');
        }
    },
    mounted() {
    }
};
</script>
